import { ConversationChannel } from '@vendasta/conversation';
import {
  ConversationChannel as ConversationChannelProto,
} from '@vendasta/protos/conversation/v1/enums';

type ConversationChannelCompat =
  | ConversationChannel
  | ConversationChannelProto;

export interface ConversationFilters {
  isAnonymous: boolean | undefined;
  isOpen: boolean | undefined;
  isPrivate: boolean;
}

export interface InboxFilters {
  channels?: ConversationChannelCompat[];
  unreadOnly?: boolean;
  awaitingResponse?: boolean;
  assignedToMe?: boolean;
  unassigned?: boolean;
}

export function hasActiveInboxFilters(filters: InboxFilters | null): boolean {
  if (!filters) return false;
  return (
    (filters.channels != null && filters.channels.length > 0) ||
    !!filters.unreadOnly ||
    !!filters.awaitingResponse ||
    !!filters.assignedToMe ||
    !!filters.unassigned
  );
}

export interface ConversationQueryConfig {
  aiAssistantId?: string | null;
}

// This array of strings allows us to type-check at dev-time and at run-time,
// using a helper method in the component. The `type InboxView` two lines down
// is a string union infererred from this array of strings. cf.
// https://dev.to/hansott/how-to-check-if-string-is-member-of-union-type-1j4m
export const inboxViewsOptions = ['none', 'closed', 'anonymous'] as const;
type InboxViewTuple = typeof inboxViewsOptions;
export type InboxView = InboxViewTuple[number];

export type InboxStatus = 'all' | 'unread' | 'awaiting';
